// extracted by mini-css-extract-plugin
export default {"pageWrapper":"PageLayout_pageWrapper__dM5sQ","bottomMenu":"PageLayout_bottomMenu__Dyips","topMenu":"PageLayout_topMenu__CmxmT"};